
import Vue, { PropType } from 'vue';
import NotificationsHeader from './NotificationsHeader.vue';
import CheckmarkOutline32 from '@carbon/icons-vue/es/checkmark--outline/32';
import NotificationToast from './NotificationToast.vue';
import { NotificationResult } from '../../typings/notification';

export default Vue.extend({
  name: 'OpenNotifications',

  components: {
    NotificationsHeader,
    CheckmarkOutline32,
    NotificationToast,
  },
  props: {
    notificationsNum: {
      type: Number,
      required: true,
      default: 0,
    },
    hasRedNotifications: {
      type: Boolean,
      required: true,
      default: false,
    },
    notifications: {
      type: [] as PropType<NotificationResult[]>,
      required: false,
      default: [],
    },
  },
});
